module.exports = __webpack_public_path__ + "public/images/partners/partner-1-1.04c5d7ca267a10d8ee0f500ef348e567.png";